// Letter encoding (docs/02-Game-Design/Level Data Format.md): one Unicode code
// point per letter, uppercase, NFC, with ß stored as ẞ (U+1E9E). Applied to
// levels, dictionary words and spelled words alike so comparison is equality.
// ß is replaced before uppercasing, because JavaScript uppercases ß to SS.

export function normalizeWord(input: string): string {
  return input.normalize('NFC').replace(/ß/g, 'ẞ').toUpperCase().normalize('NFC');
}

export function isSingleLetter(s: string): boolean {
  const points = Array.from(s);
  return points.length === 1 && s === s.normalize('NFC') && /\p{L}/u.test(s) && s === s.toUpperCase();
}

export function letterCount(word: string): number {
  return Array.from(word).length;
}
